<script setup lang="ts">

</script>

<template>
  <header class="h-[78px] min-h-[78px] flex items-center">
    <div class="container">
      <div class="title text-[25px] leading-[1.2em] text-darkGrey font-semibold">
        Appointment
      </div>
    </div>
  </header>

</template>

<style scoped lang="scss">
  header{
   border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  }
</style>